import { useEffect } from 'react';

const ensureMeta = (selector, attributes) => {
    let element = document.head.querySelector(selector);

    if (!element) {
        element = document.createElement('meta');
        Object.entries(attributes).forEach(([name, value]) => {
            element.setAttribute(name, value);
        });
        document.head.appendChild(element);
    }

    return element;
};

const Seo = ({ title, description, keywords, ogTitle, ogDescription }) => {
    useEffect(() => {
        if (title) {
            document.title = title;
        }

        const metaDescription = ensureMeta('meta[name="description"]', { name: 'description' });
        const metaKeywords = ensureMeta('meta[name="keywords"]', { name: 'keywords' });
        const openGraphTitle = ensureMeta('meta[property="og:title"]', { property: 'og:title' });
        const openGraphDescription = ensureMeta('meta[property="og:description"]', { property: 'og:description' });

        metaDescription.setAttribute('content', description || '');
        metaKeywords.setAttribute('content', Array.isArray(keywords) ? keywords.join(', ') : keywords || '');
        openGraphTitle.setAttribute('content', ogTitle || title || '');
        openGraphDescription.setAttribute('content', ogDescription || description || '');
    }, [title, description, keywords, ogTitle, ogDescription]);

    return null;
};

export default Seo;
